// 运输模式数组（默认值，会被接口数据覆盖）
let deliverModeArr = [] // 查询条件时 - 带全部
let deliverModeArr_normal = [] // 不带全部

const seasonArr = [
    {label: '全部', value: undefined},
    {label: 'Q1', value: 'Q1'},
    {label: 'Q2', value: 'Q2'},
    {label: 'Q3', value: 'Q3'},
    {label: 'Q4', value: 'Q4'},
    {label: 'Q1|Q2', value: 'Q1|Q2'},
    {label: 'Q1|Q3', value: 'Q1|Q3'},
    {label: 'Q1|Q4', value: 'Q1|Q4'},
    {label: 'Q2|Q3', value: 'Q2|Q3'},
    {label: 'Q2|Q4', value: 'Q2|Q4'},
    {label: 'Q3|Q4', value: 'Q3|Q4'},
    {label: 'Q1|Q2|Q3', value: 'Q1|Q2|Q3'},
    {label: 'Q1|Q2|Q4', value: 'Q1|Q2|Q4'},
    {label: 'Q1|Q3|Q4', value: 'Q1|Q3|Q4'},
    {label: 'Q2|Q3|Q4', value: 'Q2|Q3|Q4'},
    {label: 'Q1|Q2|Q3|Q4', value: 'Q1|Q2|Q3|Q4'},
]
const seasonArrNoDefault = [
    {label: 'Q1', value: 'Q1'},
    {label: 'Q2', value: 'Q2'},
    {label: 'Q3', value: 'Q3'},
    {label: 'Q4', value: 'Q4'},
    {label: 'Q1|Q2', value: 'Q1|Q2'},
    {label: 'Q1|Q3', value: 'Q1|Q3'},
    {label: 'Q1|Q4', value: 'Q1|Q4'},
    {label: 'Q2|Q3', value: 'Q2|Q3'},
    {label: 'Q2|Q4', value: 'Q2|Q4'},
    {label: 'Q3|Q4', value: 'Q3|Q4'},
    {label: 'Q1|Q2|Q3', value: 'Q1|Q2|Q3'},
    {label: 'Q1|Q2|Q4', value: 'Q1|Q2|Q4'},
    {label: 'Q1|Q3|Q4', value: 'Q1|Q3|Q4'},
    {label: 'Q2|Q3|Q4', value: 'Q2|Q3|Q4'},
    {label: 'Q1|Q2|Q3|Q4', value: 'Q1|Q2|Q3|Q4'},
]
// 默认的运营状态数据（初始值，会被接口数据覆盖）
let us_arr = [] // 查询条件时 - 带全部
let us_arr_normal = [] // 不带全部

export default {
    deliverModeArr,
    seasonArrNoDefault,
    seasonArr,
    us_arr,
    us_arr_normal
}
